export default {
  getDealerList: ['get', '/car_dealer/list'], // 备案车商
  getDealerId: ['get', '/car_dealer/consignor/:consignor_id'], // 备案车商详情
  postUploadImage: ['post', '/common/upload_image/'], // 上传照片
  addDealer: ['post', '/car_dealer/consignor'], // 创建备案车商
  editDealer: ['put', '/car_dealer/consignor/:consignor_id'], // 编辑备案车商
}
